import { createClient } from '@supabase/supabase-js';
import { observedFetch } from './connectivity';
import type { Database } from './database.types';
import { env } from './env';
import { captureAuthLanding } from './passwordRecovery';

// Before the client reads the address and clears its tokens: which session a password reset link opens.
captureAuthLanding();

/** Single Supabase client. Human logins and device identities both use it; what differs is who
 *  the auth user is (see docs/adr/006-auth-device-enrollment-and-pin.md). */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'didto-os-auth',
  },
  global: {
    headers: { 'x-client-info': `didto-os-staff/${env.appVersion}` },
    // every request reports whether the server was reached (ADR-037: the app is read-only without it)
    fetch: observedFetch,
  },
});
